export const masterEvent = {
    onVisibilitychangeHide: "onVisibilitychangeHide",
    onVisibilitychangeShow: "onVisibilitychangeShow",
    onNotificationInitOk: "onNotificationInitOk",
    onShowNotification: "onShowNotification",

    onPwaPlay: "onPwaPlay",
    onNotPwaPlay: "onNotPwaPlay",

    onEnter: "onEnter",
    onLeave: "onLeave",

    onUnityLoadProgress: "onUnityLoadProgress",
}

